/**
 * Locale-based currency default for the Change Plan currency picker. Same
 * region set as component/Subscription/SubscriptionsPricingTable.js's
 * euroCurrencyRegions (everywhere in Europe we don't separately price
 * defaults to EUR), minus GB — which prefers GBP first since that's a
 * currency users might reasonably expect, falling back like any other
 * unsupported preference once intersected with what's actually on offer.
 */
const EUR_REGIONS = [
  "AT", "BE", "CY", "EE", "FI", "FR", "DE", "GR", "IE", "IT", "LV", "LT",
  "LU", "MT", "NL", "PT", "SK", "SI", "ES",
  "AD", "MC", "SM", "VA", "ME", "XK",
  "BG", "HR", "CZ", "DK", "HU", "PL", "RO", "SE",
  "AL", "AM", "AZ", "BA", "BY", "CH", "GE", "IS", "LI", "MD", "MK", "NO",
  "RS", "TR", "UA",
];

/**
 * @param {string=} locale - e.g. navigator.language ("en-GB", "de-DE")
 * @returns {'gbp'|'eur'|'usd'} preferred currency, ignoring availability
 */
export function getPreferredCurrencyForLocale(locale) {
  const region = (locale || "").split("-").pop()?.toUpperCase();

  if (region === "GB") {
    return "gbp";
  }
  if (EUR_REGIONS.includes(region)) {
    return "eur";
  }
  return "usd";
}
